const MAX_CHARS_NUM = 13;
const MAX_LINES = 3;
const PX_TO_MM_RATION = 3.543;

Engravings.calculateTextTemplate = function(text, lineCharsNum) {

  function mergeText(text1, text2) {
      return text1 + ' ' + text2;
  }

  if (lineCharsNum > MAX_CHARS_NUM) {
      return null;
  }

  var textSplit = text.split(' ');

  var outputTemplate = [];
  var curLine = '';

  var wordToLong = false;

  textSplit.forEach(function(line) {
    if (line.length > lineCharsNum) {
      wordToLong = true;
    } else if (mergeText(curLine, line).length > lineCharsNum) {
      outputTemplate.push(curLine.trim());
      curLine = line;
    } else {
      curLine = mergeText(curLine, line);
    }            
  })
      
  outputTemplate.push(curLine)
  
  if (wordToLong || outputTemplate.length > MAX_LINES || curLine.length > lineCharsNum) {
      return Engravings.calculateTextTemplate(text, lineCharsNum + 1)
  } else {
      return {outputTemplate, lineCharsNum}
  }
}

// old: 'Sedgwick Ave': 'SedgwickAve', 'Zooja Regular':'ZoojaProRegular', 'Zooja Light': 'ZoojaLightPro',
Engravings.findCurrentFontFamily = function(selectedFontName) {
  let fonts = {'Helvetica': 'HelveticaBU', 'Caveat Regular': 'Caveat', 'Caveat Bold': 'Caveat', 'Cheddar Jack': 'CheddarJack', 'IvyMode': 'IvyMode', 'Sinter': 'Sinter'}
  return fonts[selectedFontName] ? fonts[selectedFontName] : selectedFontName
}

Engravings.findCurrentFontWeight = function(fontName) { 
  switch(fontName) {
    case 'Caveat Bold':
      return 'bold';
    default: 
      return 'normal';
  }
}

Engravings.findCurrentFontSize = function(fontName) {
  if (fontName == 'Aleo' || fontName == 'Poppins')
    return '0.6vw'
  else
    return '0.8vw'
}

Engravings.computeFontCharacteristics = function(lineCharsNum, small, fontName) {
  var fontFamily = Engravings.findCurrentFontFamily(fontName);
  var fontWeight = Engravings.findCurrentFontWeight(fontName);
  
  // for cup engravings we use smaller font size
  var factor = small ? 0.7 : 0.8;  // was 0.7 : 1
  
  switch(fontName) {
    // case 'Zooja Regular':
    // case 'Zooja Light':
    case 'Cheddar Jack':
    case 'Moonbright': return {fontSize: lineCharsNum < 12 ? parseInt(32 * factor) : parseInt(30 * factor), fontWeight, fontFamily}
    case 'Helvetica': return {fontSize: lineCharsNum < 12 ? parseInt(22 * factor) : parseInt(20 * factor), fontWeight, fontFamily}
    default: return {fontSize: lineCharsNum < 12 ? parseInt(28 * factor) : parseInt(26 * factor), fontWeight, fontFamily}
  }
}

Engravings.createStainlessSVG = function(outputTemplate, fontCharacteristics) {
  
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  
  svg.setAttribute('width', '50mm');
  svg.setAttribute('height', (outputTemplate.length * fontCharacteristics.fontSize / PX_TO_MM_RATION + 4) + 'mm');
  var svgNS = svg.namespaceURI;
  
  outputTemplate.forEach(function(line, index) {
  	var text = document.createElementNS(svgNS,'text');
    text.textContent = line;
    text.setAttribute('font-family', fontCharacteristics.fontFamily);
    text.setAttribute('font-size', fontCharacteristics.fontSize + 'px');
    text.setAttribute('font-weight', fontCharacteristics.fontWeight);
    text.setAttribute('style', 'text-anchor: middle;');
    text.setAttribute('x', '25mm');
    text.setAttribute('y', (fontCharacteristics.fontSize * (index + 1) / PX_TO_MM_RATION) + 'mm');
    svg.appendChild(text);
  });
  
  return svg;
}

Engravings.createShortBodyEngravingPreview = function(view) {

  let small = view.handle == 'cup' || view.handle == 'carrycup'
  var templateObject = Engravings.calculateTextTemplate(view.userText, 10);

  if (templateObject == null)
  	return null;

  var outputTemplate = templateObject.outputTemplate;
  var lineCharsNum = templateObject.lineCharsNum;  
  var fontCharacteristics = Engravings.computeFontCharacteristics(lineCharsNum, small, view.selectedFontName);
  var svg = Engravings.createStainlessSVG(outputTemplate, fontCharacteristics);
  
  view.$engravingContainer.append(svg);
}

Engravings.charWidth = function(char, fontName) {
  // If char doesn't exist in the table, return 10
  let font = Engravings.findCurrentFontFamily(fontName)
  let securedFont = Engravings.charWidthTable[font] ? Engravings.charWidthTable[font] : Engravings.charWidthTable['Aleo']
  return securedFont[char] ? securedFont[char] : 10
}

Engravings.wordWidth = function(word, fontName) {
  let wordWidth = 0
  for (char of word)
    wordWidth += Engravings.charWidth(char, fontName)

  return wordWidth
}

Engravings.formatTextShortBody = function(userText, view) {
  let tpl = Engravings.calculateTextTemplate(userText, 10)?.outputTemplate || []
  if (tpl[0] == '') tpl.shift()
  return tpl.join('<br>')
}

Engravings.formatText = function(userText, view) {

  const LIMIT = 290
  let words = userText.split(' ')
  let result = []
  let counter = 0
  
  while (words.length > 0) {
  	let word = words[0]
    let wordWidth = Engravings.wordWidth(word, view.selectedFontName)

    // Not enough spaces in text
  	if (wordWidth > LIMIT) return null
    
  	if (counter + wordWidth < LIMIT) {
  		result.push(word)
  		words.shift()
  		counter += wordWidth + Engravings.wordWidth(' ', view.selectedFontName)
  	} else {
  		result.push('<br>')
  		counter = 0
  	}
  }

  return result.join(' ').replaceAll(' <br> ', ' <br>')
}

Engravings.createLongBodyEngravingPreview = function(view) {
  view.$engravingContainer.html(view.$userTextFormatted.val()) 
  let font = Engravings.findCurrentFontFamily(view.selectedFontName)
  let weight = Engravings.findCurrentFontWeight(view.selectedFontName)
  let size = Engravings.findCurrentFontSize(view.selectedFontName)
  let divider = Engravings.fontSizeRatio[font] * (Engravings.fontSizeFactor[view.handle.replace('_dw', '')] || 1)
  view.$engravingContainer.css({'font-family': font, 'font-weight': weight}).attr('data-handle', view.handle)
  // Adjust font-size to match current img size.
  // The delay is needed because img height was sometimes not available at the moment of calculations.
  setTimeout(function() {
    let picHeight = view.$img.height()
    view.$engravingContainer.css({'font-size': picHeight/divider + 'px'})
  }, 100)
}

Engravings.fontSizeRatio = { Aleo: 40, Caveat: 40, Moonbright: 40, CheddarJack: 37, Poppins: 46, IvyMode: 40, Sinter: 40, Amertha: 40 }
Engravings.fontSizeFactor = { cup: 1, timeless600: 1.3, timeless1000: 1.3, smart: 1.3, stainless: 1.3, carrycup: 1.3 }

// Width of each char for a specific font. Get these numbers for any font using Engravings.measureFontWidth()
Engravings.charWidthTable = {
  "Aleo": {"0":9,"1":7,"2":8,"3":8,"4":9,"5":8,"6":8,"7":8,"8":8,"9":8,"a":8,"b":9,"c":7,"č":7,"d":9,"e":8,"f":5,"g":8,"h":10,"i":5,"j":4,"k":9,"l":5,"m":13,"n":10,"o":9,"p":9,"r":7,"s":7,"š":7,"t":6,"u":9,"v":9,"z":7,"ž":7,"đ":8,"x":9,"y":9,"w":13,"A":12,"B":10,"C":10,"Č":10,"D":11,"E":9,"F":9,"G":10,"H":12,"I":5,"J":7,"K":11,"L":9,"M":14,"N":12,"O":12,"P":9,"R":10,"S":8,"Š":8,"T":10,"U":11,"V":12,"Z":9,"Ž":9,"Đ":11,"X":11,"Y":11,"W":17,"\"":5,"?":7,"!":4,"*":6,":":4,"(":4,")":4,"♥":11,"⌣":9,"☆":10,"☉":9,"☋":12,"☌":10,".":4,",":4," ":3},
  "Caveat":{"0":7,"1":7,"2":7,"3":7,"4":7,"5":7,"6":7,"7":7,"8":7,"9":7,"a":7,"b":7,"c":6,"č":6,"d":6,"e":5,"f":5,"g":6,"h":7,"i":3,"j":4,"k":6,"l":3,"m":9,"n":7,"o":6,"p":6,"r":6,"s":6,"š":6,"t":5,"u":6,"v":6,"z":5,"ž":5,"đ":6,"x":6,"y":6,"w":8,"A":8,"B":8,"C":7,"Č":8,"D":9,"E":8,"F":7,"G":8,"H":9,"I":7,"J":5,"K":8,"L":7,"M":11,"N":9,"O":8,"P":7,"R":8,"S":8,"Š":8,"T":7,"U":8,"V":8,"Z":8,"Ž":8,"Đ":9,"X":8,"Y":8,"W":11,"\"":4,"?":6,"!":4,"*":6,":":4,"(":5,")":5,"♥":8,"⌣":9,"☆":9,"☉":8,"☋":10,"☌":9,".":4,",":4," ":4},
  "Moonbright":{"0":7,"1":4,"2":5,"3":5,"4":5,"5":6,"6":5,"7":4,"8":5,"9":5,"a":7,"b":6,"c":5,"č":5,"d":6,"e":5,"f":4,"g":6,"h":7,"i":4,"j":3,"k":6,"l":4,"m":10,"n":7,"o":5,"p":6,"r":6,"s":4,"š":4,"t":4,"u":7,"v":5,"z":5,"ž":5,"đ":6,"x":5,"y":7,"w":8,"A":7,"B":6,"C":7,"Č":7,"D":7,"E":6,"F":6,"G":7,"H":8,"I":5,"J":5,"K":7,"L":5,"M":11,"N":8,"O":9,"P":6,"R":7,"S":6,"Š":6,"T":6,"U":7,"V":6,"Z":6,"Ž":6,"Đ":7,"X":6,"Y":6,"W":9,"\"":5,"?":4,"!":4,"*":7,":":3,"(":4,")":5,"♥":8,"⌣":10,"☆":9,"☉":8,"☋":10,"☌":9,".":3,",":3," ":5},
  "CheddarJack":{"0":4,"1":3,"2":4,"3":3,"4":4,"5":3,"6":4,"7":4,"8":4,"9":4,"a":5,"b":5,"c":4,"č":4,"d":5,"e":4,"f":4,"g":5,"h":5,"i":3,"j":4,"k":5,"l":4,"m":6,"n":5,"o":4,"p":5,"r":5,"s":4,"š":5,"t":4,"u":5,"v":5,"z":4,"ž":4,"đ":6,"x":5,"y":5,"w":7,"A":7,"B":7,"C":9,"Č":9,"D":9,"E":6,"F":9,"G":8,"H":10,"I":4,"J":7,"K":7,"L":8,"M":10,"N":7,"O":8,"P":7,"R":9,"S":8,"Š":8,"T":9,"U":9,"V":9,"Z":7,"Ž":7,"Đ":9,"X":9,"Y":9,"W":11,"\"":3,"?":4,"!":3,"*":5,":":2,"(":5,")":5,"♥":8,"⌣":9,"☆":9,"☉":8,"☋":10,"☌":10,".":2,",":2," ":3},
  "Poppins":{"0":8,"1":7,"2":8,"3":8,"4":8,"5":8,"6":8,"7":8,"8":8,"9":8,"a":7,"b":8,"c":7,"č":7,"d":8,"e":7,"f":5,"g":8,"h":8,"i":5,"j":5,"k":8,"l":5,"m":12,"n":8,"o":8,"p":8,"r":5,"s":6,"š":6,"t":5,"u":8,"v":8,"z":7,"ž":7,"đ":8,"x":8,"y":8,"w":11,"A":11,"B":10,"C":10,"Č":10,"D":11,"E":9,"F":9,"G":11,"H":11,"I":5,"J":6,"K":11,"L":9,"M":13,"N":11,"O":11,"P":9,"R":10,"S":9,"Š":9,"T":9,"U":11,"V":11,"Z":9,"Ž":9,"Đ":11,"X":11,"Y":11,"W":14,"\"":7,"?":7,"!":5,"*":8,":":5,"(":5,")":5,"♥":9,"⌣":14,"☆":12,"☉":13,"☋":11,"☌":8,".":4,",":4," ":4},
  // "IvyMode": {"0":9,"1":7,"2":8,"3":8,"4":9,"5":8,"6":8,"7":8,"8":8,"9":8,"a":8,"b":9,"c":7,"č":7,"d":9,"e":8,"f":5,"g":8,"h":10,"i":5,"j":4,"k":9,"l":5,"m":13,"n":10,"o":9,"p":9,"r":7,"s":7,"š":7,"t":6,"u":9,"v":9,"z":7,"ž":7,"đ":8,"x":9,"y":9,"w":13,"A":12,"B":10,"C":10,"Č":10,"D":11,"E":9,"F":9,"G":10,"H":12,"I":5,"J":7,"K":11,"L":9,"M":14,"N":12,"O":12,"P":9,"R":10,"S":8,"Š":8,"T":10,"U":11,"V":12,"Z":9,"Ž":9,"Đ":11,"X":11,"Y":11,"W":17,"\"":5,"?":7,"!":4,"*":6,":":4,"(":4,")":4,"♥":11,"⌣":9,"☆":10,"☉":9,"☋":12,"☌":10,".":4,",":4," ":3},
  "IvyMode":{"0":8,"1":7,"2":8,"3":8,"4":8,"5":8,"6":8,"7":8,"8":8,"9":8,"a":7,"b":8,"c":7,"č":7,"d":8,"e":7,"f":5,"g":8,"h":8,"i":5,"j":5,"k":8,"l":5,"m":12,"n":8,"o":8,"p":8,"r":5,"s":6,"š":6,"t":5,"u":8,"v":8,"z":7,"ž":7,"đ":8,"x":8,"y":8,"w":11,"A":11,"B":10,"C":10,"Č":10,"D":11,"E":9,"F":9,"G":11,"H":11,"I":5,"J":6,"K":11,"L":9,"M":13,"N":11,"O":11,"P":9,"R":10,"S":9,"Š":9,"T":9,"U":11,"V":11,"Z":9,"Ž":9,"Đ":11,"X":11,"Y":11,"W":14,"\"":7,"?":7,"!":5,"*":8,":":5,"(":5,")":5,"♥":9,"⌣":14,"☆":12,"☉":13,"☋":11,"☌":8,".":4,",":4," ":4},
  "Amertha": {"0":7,"1":7,"2":7,"3":7,"4":7,"5":7,"6":7,"7":7,"8":7,"9":7,"a":7,"b":7,"c":7,"č":7,"d":7,"e":7,"f":5,"g":7,"h":7,"i":4,"j":4,"k":7,"l":4,"m":11,"n":7,"o":7,"p":7,"r":5,"s":6,"š":6,"t":4,"u":7,"v":7,"z":7,"ž":7,"đ":7,"x":7,"y":7,"w":11,"A":11,"B":10,"C":10,"Č":10,"D":11,"E":9,"F":8,"G":11,"H":11,"I":5,"J":6,"K":11,"L":9,"M":13,"N":11,"O":11,"P":8,"R":10,"S":8,"Š":8,"T":9,"U":11,"V":11,"Z":9,"Ž":9,"Đ":11,"X":11,"Y":11,"W":14,"\"":6,"?":7,"!":5,"*":7,":":4,"(":5,")":5,"♥":9,"⌣":14,"☆":12,"☉":12,"☋":11,"☌":8,".":4,",":4," ":4}
}

// Run this function in console to get correct char widths, then paste the result into the Engravings.charWidthTable object.
Engravings.measureFontWidth = function() {
  let abc = 'abcčdefghijklamnoprsštuvzžđxywABCČDEFGHIJKLAMNOPRSŠTUVZŽĐXYW1234567890"?!*:()♥⌣☆☉☋☌., '
  let counter = 0
  let lens = {}
  let font = 'Amertha'
  
  for (char of abc) {
    let s = ''
    if (char==' ') char = '&nbsp;'
    for (let i=0; i<10; i++) s += char
    let id = 'span_id_' + counter
    $('body').prepend('<span id="'+id+'" style="font-family: '+font+';">'+s+'</span><br>')
    let len = Math.ceil($('#'+id).width() / 10)
      
    // if (!lens[len]) lens[len] = [char]
    // else lens[len].push(char)

    if (!lens[font]) lens[font] = {}
    lens[font][char] = len
    
    counter++
  }
  console.log('++++++ CHAR WIDTHS ++++++')
  console.log(lens)
}


if (g_product) {
  $(window).resize(function() {
    if (Engravings.AllEngravingForms.length)
      Engravings.AllEngravingForms[0].refresh()   //doesn't work?
  });
}